import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function CodeIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M11.943 13c.757 0 1.371-.64 1.371-1.429V8.714L14 8l-.686-.714V4.429c0-.79-.614-1.429-1.371-1.429M4.057 3c-.757 0-1.371.64-1.371 1.429v2.857L2 8l.686.714v2.857c0 .79.614 1.429 1.371 1.429M6.2 11.125l3.6-6.25" /></svg>
  );
}

export default CodeIcon;
